import { Navigate, useParams } from 'react-router-dom';

/**
 * Legacy-route catcher for the old AgentVoice + PhoneTesting pages.
 *
 * `/agents/:id/voice` and `/agents/:id/phone` used to be two
 * separate test surfaces; PR-B collapsed both into the merged
 * `/agents/:id/playground` page (web-voice on the left, phone
 * testing on the right). Bookmarks, inbound deep links from the
 * (now-removed) Mic/Phone row buttons, and any external links
 * still land on those URLs — this component bounces them to the
 * merged page while preserving the `:id` param.
 *
 * `replace` keeps the back-button working: after the bounce the
 * user can hit Back and land on whatever brought them here, not
 * the legacy URL.
 */
export function RedirectToPlayground() {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={`/agents/${id ?? ''}/playground`} replace />;
}
